module.exports = __webpack_public_path__ + "static/media/25_爱给网_aigei_com.fa01eb5a.mp3";